export { default as CreateFormPageMixin } from "./form_page_mixin";
export { default as CreateCodeTableFetchMixin } from "./code_table_fetch_mixin";
export { default as CreateListPageMixin } from "./list_page_mixin";
export { default as VuelidateMixin } from "./vuelidate_mixin";
export { default as CreateFormStateMixin } from "./form_state_mixin";
export { default as CreateGroupPermissionMixin } from "./group_permission_mixin";
export { default as UseRestModuleMixin } from "./UseRestModuleMixin";
export { default as MultiActionsMixin } from "./MultiActionsMixin";
export { default as UseRestActionModuleMixin } from "./UseRestActionModuleMixin";

export const UnsavedMixin = {
    beforeRouteLeave(to, from, next) {
        if (this.formState.dirty) {
            const answer = window.confirm(
                "Do you really want to leave? you have unsaved changes!"
            );
            if (answer) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
};
